import React from "react";
import { ErrorMessage } from "@hookform/error-message";

export default function BranchStep4({
  register,
  changeStep,
  step,
  errors,
  isValid,
  trigger,
  isFormProcessing,
  setIs_new_account,
  is_new_account,
  reset, // from useForm
  watch, // from useForm
}) {
  const handleResetBank = () => {
  setIs_new_account(true);

  // Get all current form values
  const currentValues = watch();

  // Reset, but keep all other fields while clearing bank fields
  reset(
    {
      ...currentValues, // keep everything
      account_title: "",
      account_type: "",
      account_number: "",
      routing_number: "",
    },
    { keepErrors: true, keepDirty: false }
  );
};


  return (
    <>
      <fieldset>
        <div className="row form_row">
          <div
            className={`col-xs-12 info_heading_confirm ${
              !is_new_account ? "bankFlex" : ""
            }`}
          >
            <h4>Bank Account</h4>
            {!is_new_account && (
              <span onClick={handleResetBank}>Reset & Add New Bank Details</span>
            )}
          </div>

          {/* Account Title */}
          <div className="col-xs-6">
            <h6>Account Title</h6>
            <div className="form_blk">
              <input
                type="text"
                className="txtBox"
                disabled={!is_new_account}
                {...(is_new_account
                  ? register("account_title", {
                      pattern: {
                        value: /^[a-zA-Z][a-zA-Z ]*$/,
                        message: "Invalid value",
                      },
                      required: "Required",
                    })
                  : register("account_title"))} // still register so RHF can show saved value
              />
              <ErrorMessage
                errors={errors}
                name="account_title"
                render={({ message }) => (
                  <p className="error">
                    <i className="fi-warning"></i> {message}
                  </p>
                )}
              />
            </div>
          </div>

          {/* Account Type */}
          <div className="col-xs-6">
            <h6>Account Type</h6>
            <div className="form_blk">
              <select
                className="txtBox"
                disabled={!is_new_account}
                {...(is_new_account
                  ? register("account_type", { required: "Required" })
                  : register("account_type"))}
              >
                <option value="">Select Account Type</option>
                <option value="C">Checking Account</option>
                <option value="S">Savings Account</option>
              </select>
              <ErrorMessage
                errors={errors}
                name="account_type"
                render={({ message }) => (
                  <p className="error">
                    <i className="fi-warning"></i> {message}
                  </p>
                )}
              />
            </div>
          </div>

          {/* Account Number */}
          <div className="col-xs-6">
            <h6>Account Number</h6>
            <div className="form_blk">
              <input
                type="text"
                className="txtBox"
                disabled={!is_new_account}
                {...(is_new_account
                  ? register("account_number", { required: "Required" })
                  : register("account_number"))}
              />
              <ErrorMessage
                errors={errors}
                name="account_number"
                render={({ message }) => (
                  <p className="error">
                    <i className="fi-warning"></i> {message}
                  </p>
                )}
              />
            </div>
          </div>

          {/* Routing Number */}
          <div className="col-xs-6">
            <h6>Routing Number</h6>
            <div className="form_blk">
              <input
                type="text"
                className="txtBox"
                disabled={!is_new_account}
                {...(is_new_account
                  ? register("routing_number", { required: "Required" })
                  : register("routing_number"))}
              />
              <ErrorMessage
                errors={errors}
                name="routing_number"
                render={({ message }) => (
                  <p className="error">
                    <i className="fi-warning"></i> {message}
                  </p>
                )}
              />
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="cmnBtn text-center">
          <button
            type="button"
            className="webBtn backBtn"
            onClick={() => changeStep(step - 1)}
          >
            Previous
          </button>
          {!isValid ? (
            <button
              type="button"
              className="webBtn colorBtn nextBtn"
              onClick={() => trigger()}
            >
              Submit
            </button>
          ) : (
            <button
              type="submit"
              className="webBtn colorBtn"
              disabled={isFormProcessing === true}
            >
              {isFormProcessing === true ? <i className="spinner"></i> : "Submit"}
            </button>
          )}
        </div>
      </fieldset>
    </>
  );
}
